import React from 'react';

const RetailSale: React.FC = () => {
  return (
    <div className="max-w-6xl mx-auto space-y-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Retail Sales</h1>
        <p className="text-gray-600">
           Retail sales refer to selling goods directly to end customers for personal use.
          Recording retail sales accurately is crucial for managing inventory, tracking revenue,
          and ensuring smooth customer transactions.
        </p>
      </div>

      {/* Retail Sale Overview */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">Retail Sales Overview</h2>
        <p className="text-gray-600 mb-4">
          Retail Sale  in DAS represent amounts owed to customers for goods or services received. Retail sale can be created
          directly or generated from sale orders when items are received.
        </p>

        <div className="mb-6">
          <img
            src="/images/sales/retail-sales/list.png"
            alt="Bills List View"
            className="w-full border border-gray-300 rounded-lg shadow-sm"
          />
        </div>
      </div>



      {/* Search and Filtering */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">Search and Filtering Retail Sale</h2>
        <p className="text-gray-600 mb-4">
          Efficiently locate and manage retail sale using comprehensive search and filtering options with multiple criteria.
        </p>

        <div className="mb-6">
          <img
            src="/images/sales/retail-sales/search-form.png"
            alt="Bills Search Dialog"
            className="w-full border border-gray-300 rounded-lg shadow-sm"
          />
        </div>

        <h3 className="text-lg font-semibold text-gray-800 mb-3">Advanced Search Dialog</h3>
        <p className="text-gray-600 mb-4">
          Use the comprehensive search dialog to find specific bills with multiple filter criteria:
        </p>
        <div className="grid md:grid-cols-2 gap-6 mb-6">
          <div>
            <p className="text-gray-600 mb-2"><strong>Identification Filters:</strong></p>
            <ul className="list-disc list-inside text-gray-600 space-y-1 text-sm">
              <li><strong>Invoice #:</strong> Search by specific bill number</li>
              <li><strong>Invoice Date Rage:</strong> Find by supplier's invoice reference</li>
              <li><strong>Branch:</strong> Filter by product batch numbers</li>
            </ul>
          </div>
        </div>



        <h3 className="text-lg font-semibold text-gray-800 mb-3">Quick Search with Search Icon</h3>
        <p className="text-gray-600 mb-4">
          Use the search icon (🔍) in the top-right corner for instant bill filtering:
        </p>
      </div>





      {/* Bill Tracking and Integration */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">Payment Tracking and Integration</h2>
        <p className="text-gray-600 mb-4">
          Track payment relationships with payments, purchase orders, and view detailed transaction history.
        </p>

        <h3 className="text-lg font-semibold text-gray-800 mb-3">Payment Tabs</h3>
        <div className="mb-6">
          <img
            src="/images/sales/retail-sales/payment-form.png"
            alt="Payments Made Tab"
            className="w-full border border-gray-300 rounded-lg shadow-sm"
          />
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-6">
          <div>
            <p className="text-gray-600 mb-2"><strong>Payments Made Tab:</strong></p>
            <ul className="list-disc list-inside text-gray-600 space-y-1 text-sm">
              <li>Complete payment history for the retail sales</li>
            </ul>
          </div>

        </div>
      </div>
    </div>
  );
};

export default RetailSale;
